<ng-template #purchasedetails let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Purchase Information</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('cancel')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">

		<ng-container>
			<h4>Update Item</h4>
			<div class="row" *ngIf="purchase_item">
				<div class="col-3 mt-3">
					<button mat-raised-button color="primary" (click)="nonStockItem(purchase_item)">NON STOCK ITEM?</button>
				</div>

				<div class="col-md-2">
					<mat-form-field appearance="outline">
						<mat-label>MIN</mat-label>
						<span matPrefix>#</span>
						<input matInput (input)="setMin($event.target.value,purchase_item)" type="number" value="{{ purchase_item.minimum | number }}" class="text-right">
						<span matSuffix></span>
					</mat-form-field>
				</div>
				<div class="col-md-2">
					<mat-form-field appearance="outline">
						<mat-label>MAX</mat-label>
						<span matPrefix>#</span>
						<input matInput (input)="setMax($event.target.value,purchase_item)" type="number" value="{{ purchase_item.maximum | number }}" class="text-right">
					</mat-form-field>
				</div>
				<div class="col-md-2">
					<mat-form-field appearance="outline" class="">
						<mat-label>
							BIN
						</mat-label>
						<input matInput value="{{ purchase_item.bin }}" class="text-right" (input)="setBin($event.target.value,purchase_item)">
					</mat-form-field>
				</div>
				<div class="col-3 mt-3 text-right">
					<button mat-raised-button color="accent" (click)="updateItem(purchase_item)">
						<mat-icon>save</mat-icon> SAVE
					</button>
				</div>
			</div>
		</ng-container>
		<app-purchase-data [item]="purchase_item" (newitemdata)="updatePurchaseData($event, purchase_item)"></app-purchase-data>
		<ng-container *ngIf="purchase_item.itemhistory">
			<mat-divider></mat-divider>
			<table class="table table-sm smaller-font" *ngFor="let year of purchase_item.itemhistory.years">
				<tr>
					<th></th>
					<th *ngFor="let month of year.sales">
						{{ month.label }} {{ month.year }}
					</th>
				</tr>
				<tr>
					<td class="text-left">Qty</td>
					<td class="text-right" *ngFor="let month of year.qty">
						{{ month.value | number:'1.0-0' }}
					</td>
				</tr>
				<tr>
					<td class="text-left">Cost </td>
					<td class="text-right" *ngFor="let month of year.cost">
						{{ month.value | currency }}
					</td>
				</tr>
			</table>
		</ng-container>
		<mat-divider></mat-divider>
		<div class="row" *ngIf="purchase_item">
			<div [ngClass]="purchase_item.purchdata.length == 1 ? 'col-md-12': 'col-md-6'" *ngFor="let pdata of purchase_item.purchdata">
				<div class="card highlight" (click)="setPurchOrderOptions(purchase_item, pdata)" [ngClass]="(pdata.supplierid == purchase_item.selected_option.supplierno) ? 'highlighted' : '' ">
					<div class="card-header text-center">
						<h4 class="card-title text-center">{{ pdata.supplierid }}: {{ pdata.suppname }} <b>{{ pdata.price | currency }}</b></h4>
					</div>
					<div class="card-body text-center">
						<div class="col-12">
							<h5>{{ pdata.stockid }} {{ pdata.supplierdescription }}</h5>
						</div>
						<div class="col-12 p-0 m-0">
							<ul class="entry-list p-0 m-0" *ngFor="let remote of pdata.remote">
								<li>
									<div class="spec-label">{{ remote.feedlabel }}:</div>
									<div class="spec-value">{{ remote.qty }}</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>
<ng-template #itemhistoryele let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Item Sales History {{ item.item.stockid }} {{ purchitem.indexmonth }}</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="text-center" *ngIf="itemhistory">
			<p class="text-left" *ngIf="item.descriptions.description"> {{ item.descriptions.description }} </p>
			<p class="text-left" *ngIf="item.descriptions.benefits"> {{ item.descriptions.benefits }} </p>

			<div class="row smaller-font">
				<div class="col-md-3 ml-0 mr-0 pl-0 pr-0" [ngClass]="purchitem.remote_inventory ? 'col-md-3' : 'col-md-3'">
					<ul class="entry-list p-0 m-0 bold">
						<li>
							<div class="spec-label">Target:</div>
							<div class="spec-value">{{ purchitem.target  }}</div>
						</li>
						<li>
							<div class="spec-label">Avg Sales:</div>
							<div class="spec-value">{{ purchitem.weekly_sales_amt }}</div>
						</li>
					</ul>
				</div>
				<div class="col-md-3 ml-0 mr-0 pl-0 pr-0">
					<ul class="entry-list p-0 m-0 bold">
						<li>
							<div class="spec-label">QOH:</div>
							<div class="spec-value">{{ purchitem.qoh }}</div>
						</li>
						<li>
							<div class="spec-label">Back Order:</div>
							<div class="spec-value">{{ purchitem.qos }}</div>
						</li>
						<li>
							<div class="spec-label">On Order:</div>
							<div class="spec-value">{{ purchitem.qop }}</div>
						</li>
					</ul>
				</div>
				<div class="col-md-3 ml-0 mr-0 pl-0 pr-0">
					<ul class="entry-list p-0 m-0 bold">
						<li>
							<div class="spec-label">Avail:</div>
							<div class="spec-value">{{ ( purchitem.qoh + purchitem.qop ) - purchitem.qos }}</div>
						</li>
						<li>
							<div class="spec-label">Net Avg:</div>
							<div class="spec-value">{{ purchitem.seasonaldetails.grandaverage | number:'1.0-0'}}</div>
						</li>
						<li>
							<div class="spec-label">Net Total:</div>
							<div class="spec-value">{{ purchitem.seasonaldetails.grandtotal | number:'1.0-0' }}</div>
						</li>
					</ul>
				</div>
				<div class="col-md-3 ml-0 mr-0 pl-0 pr-0">
					<ul class="entry-list p-0 m-0 bold">
						<li>
							<div class="spec-label">Period Target:</div>
							<div class="spec-value">{{ purchitem.qty_purchase }}</div>
						</li>
						<li>
							<div class="spec-label">Avg Month Recommend:</div>
							<div class="spec-value">{{ purchitem.avg_recomendation | number:'1.0-0' }}</div>
						</li>
						<li>
							<div class="spec-label">Seasonal Recommend:</div>
							<div class="spec-value">{{ purchitem.seasonal_recomendation | number:'1.0-0' }}</div>
						</li>
					</ul>
				</div>
				<div class="col-md-4 ml-0 mr-0 pl-0 pr-0 d-none">
					<div class="row m-0 p-0">
						<div class="col-12" *ngIf="purchitem.remote_inventory">
							<ul class="entry-list p-0 m-0 bold" *ngFor="let remote of purchitem.remote_inventory">
								<li>
									<div class="spec-label">{{ remote.feedlabel }}:</div>
									<div class="spec-value">{{ remote.qty }}</div>
								</li>
							</ul>
						</div>
						<div class="col-md-12" *ngIf="!item.remote_inventory">
							<ul class="entry-list p-0 m-0 bold">
								<li>
									<div class="spec-label">n/a:</div>
									<div class="spec-value">n/a</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<table class="table table-sm smaller-font" *ngFor="let year of itemhistory.years">
				<tr>
					<th></th>
					<th *ngFor="let month of year.sales" [ngClass]="{'highlighted-solid': futuremonths.indexOf(month.label)>= 0,
								'highlighted-prev': months.indexOf(month.label) >= 0}">
						{{ month.label }} {{ month.year }}
					</th>
				</tr>
				<tr>
					<td class="text-left">Qty</td>
					<td class="text-right" *ngFor="let month of year.qty">
						{{ month.value | number:'1.0-0' }}
					</td>
				</tr>
				<tr>
					<td class="text-left">Sales </td>
					<td class="text-right" *ngFor="let month of year.sales" [ngClass]="{'highlighted-solid': futuremonths.indexOf(month.label) >= 0,'highlighted-prev': months.indexOf(month.label) >= 0}">
						{{ month.value | currency }}
					</td>
				</tr>
				<tr>
					<td class="text-left">Cost </td>
					<td class="text-right" *ngFor="let month of year.cost">
						{{ month.value | currency }}
					</td>
				</tr>
				<!--<tr>
							<td class="text-left">M Season</td>
							<td class="text-right" *ngFor="let month of purchitem.seasonals" >
								{{ month.projection | number:'1.0-0' }}
							</td>
						</tr>
						<tr>
							<td class="text-left">M Avg</td>
							<td class="text-right" *ngFor="let month of purchitem.seasonals" >
								{{ month.avg | number:'1.0-0' }}
							</td>
						</tr>
						-->
				<tr>
					<td class="text-left">Index</td>
					<td class="text-right" *ngFor="let month of purchitem.seasonals">
						{{ month.index | percent }}
					</td>
				</tr>
			</table>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>
<form [formGroup]="reportForm" *ngIf="reportForm" class="no-overflow">
	<div *ngIf="lastCreatedPos.length" class="alert alert-success alert-dismissible fade show mb-3 d-flex align-items-center flex-wrap gap-2" role="alert">
		<span>{{ lastCreatedPos.length === 1 ? 'PO #' + lastCreatedPos[0].orderno + ' created.' : lastCreatedPos.length + ' POs created.' }}</span>
		<a *ngIf="lastCreatedPos.length" [routerLink]="['/purchasing', lastCreatedPos[0].supplierno, lastCreatedPos[0].orderno]" class="alert-link">View PO</a>
		<button type="button" class="btn-close ms-auto" aria-label="Close" (click)="dismissPoSuccess()"></button>
	</div>
	<div *ngIf="poCreateError" class="alert alert-danger alert-dismissible fade show mb-3" role="alert">
		<strong>PO failed.</strong> {{ poCreateError }}
		<button type="button" class="btn-close" aria-label="Close" (click)="dismissPoError()"></button>
	</div>
	<div class="row p-0 m-0 " *ngIf="filters">
		<div class="col-md-2">
			<mat-form-field appearance="outline">
				<mat-label>Warehouse</mat-label>
				<mat-select formControlName="loccode">
					<mat-option *ngFor="let loc of locations" [value]="loc.loccode">
						{{ loc.locationname }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

		<ng-container *ngFor="let filter of filters">
			<div class="col-auto">
				<ng-container *ngIf="filter.input_type == 'select'">
					<div class="row">
						<mat-form-field appearance="outline" class="col-12">
							<mat-label>{{ filter.name }}</mat-label>
							<mat-select [(value)]="filter.default_value" (selectionChange)="updateSearchSelect($event, filter.filter_id)">
								<mat-option *ngFor="let opt of filter.options" [value]="opt.value">
									{{opt.label }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</ng-container>
				<ng-container *ngIf="filter.input_type == 'checkbox'">
					<div class="row">
						<mat-checkbox class="col-6" *ngFor="let opt of filter.options" [value]="opt.value" (change)="updateChecks($event, filter.filter_id)">
							{{opt.label }}
						</mat-checkbox>
					</div>
				</ng-container>

				<ng-container *ngIf="filter.input_type == 'text'">
					<mat-form-field appearance="outline">
						<mat-label>{{ filter.name }}</mat-label>
						<input type="text" class="text-let m-0 p-0" matInput (input)="updateSearchSelect($event.target, filter.filter_id)" />
					</mat-form-field>
				</ng-container>

				<ng-container *ngIf="filter.input_type == 'multis'">
					<div class="row" *ngIf="filter.options">
						<mat-form-field appearance="outline" class="col-12">
							<mat-label>{{ filter.name }}</mat-label>
							<mat-select (selectionChange)="updateSearchSelectMulti($event, filter.filter_id)" multiple [value]="filter.default_value">
								<mat-option *ngFor="let opt of filter.options" [value]="opt.value">
									{{ opt.label }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</ng-container>

				<mat-divider></mat-divider>
			</div>
		</ng-container>
	</div>
</form>
<div class="row m-0 p-0">
	<div class="col-md-12 ">
		<div class="row p-2 md-0x border-bottom">
			<div class="col-12 text-left">
				<button mat-raised-button color="warn" (click)="getRecomendations()">Run</button>
				&nbsp;&nbsp;
				<button mat-raised-button color="accent" (click)="exportXls()" *ngIf="po_vendors_found">
					<i class="fa fa-file-excel-o"></i>&nbsp;&nbsp;XLS</button>
			</div>
			<div class="col-12">
				<div class="table table-responsive text-center" *ngIf="loading">
					<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
						<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30">
						</circle>
					</svg>
				</div>
			</div>
		</div>
		<ng-container *ngIf="!loading">
			<ng-container *ngIf="hasNoResults">
				<h4 class="mt-3">No Results</h4>
			</ng-container>
			<ng-container *ngIf="!hasNoResults && results">
				<mat-tab-group>
					<mat-tab label="Results">
						<div class="table mt-2" *ngIf="po_vendors_found.length">
							<div class="container-fluid tp-box" [@flipState]="flip">
								<div class="row tp-box__side tp-box__front no-overflow">
									<mat-stepper #stepper (selectedIndex)="currentstep" class="w-100">
										<mat-step errorMessage="Review Results">
											<ng-template matStepLabel>{{ reviewlabel }}</ng-template>

											<div class="row mt-3 mb-3 no-overflow">

												<div class="col-12 text-right">
													<button mat-raised-button color="accent" matStepperNext>Next</button>
												</div>

												<div class="col-12 mt-3">

													<!--<mat-slide-toggle [formControl]="fully_available" (change)="filterResults($event)" (checked)="fully_available.value">Available to Purchase Only?</mat-slide-toggle>
											-->
													<div class="table" *ngFor="let vendor of po_vendors_found">



														<h4 class="card-title text-left mt-3">{{ vendor }}</h4>



														<div class="wrapper">
															<table class="table table-fixed w-100">
																<thead>
																	<tr>
																		<th class="header"></th>
																		<th class="header">Vendor</th>
																		<th class="header">Item</th>

																		<th class="header text-center">YTD Qty Sales</th>
																		<th class="header">QOH</th>
																		<th class="header text-center">Committed</th>
																		<th class="header text-center">OnOrder</th>
																		<th class="header text-center">Avail</th>
																		<th class="header">MIN</th>
																		<th class="header">MAX</th>
																		<th class="header text-right">Remote Avail</th>
																		<th class="header text-right">Price</th>
																		<th class="header text-right">Order</th>
																		<th class="header text-right">Qty</th>
																	</tr>
																</thead>
																<tbody>
																	<tr *ngFor="let item of results[vendor]">
																		<td>
																			<button class="mb-0 pt-0 pb-0 " mat-icon-button color="accent" (click)="removeItem(item,vendor)">
																				<mat-icon>remove</mat-icon>
																			</button>

																			<button class="mb-0 pt-0 pb-0 " mat-icon-button color="warn" (click)="viewPurchData(item)">
																				<mat-icon>settings</mat-icon>
																			</button>
																		</td>
																		<td>{{ item.vendor }}</td>
																		<!--<td (click)="getItemHistory(item)"> {{ item.stockid }}</td>-->
																		<td><b>{{ item.brand_data.brand }}</b><br>{{ item.stockid }}<br />
																			{{ item.description }}
																		</td>

																		<td class="text-center">{{ item.itemhistory.totals.thisyear_total_qty | number:'1.0-0' }}</td>
																		<td class="text-center">{{ item.qoh }}</td>
																		<td class="text-center">{{ item.qos }}</td>
																		<td class="text-center">{{ item.qop }}</td>
																		<td class="text-center">{{ ( item.qoh + item.qop ) - item.qos }}</td>

																		<td class="text-center">{{ item.minimum }}</td>
																		<td class="text-center">{{ item.maximum }}</td>
																		<td class="text-center">{{ item.total_available }}</td>
																		<td class="text-right">
																			{{ item.price | currency }}
																			<!--<input matInput type="text" placeholder="Price" [(value)]="item.price" (input)="updatePrice($event.target.value, item)"> -->
																		</td>
																		<td class="text-right">{{ item.target_purchase }}</td>
																		<td class="text-right bolder" [ngClass]="{'bg-danger text-white bolder': item.total_available == 0 , 'bg-warning text-dark bolder': item.target_purchase > item.total_available && item.total_available > 0 }">
																			<input matInput type="number" class="form-control" placeholder="Purchase Qty" [(value)]="item.qty_purchase" (input)="updateQuantity($event.target.value, item)" appSelectOnFocus>
																		</td>
																	</tr>
																</tbody>
															</table>
														</div>
													</div>
												</div>
											</div>
										</mat-step>
										<mat-step errorMessage="Verify Fillable">
											<ng-template matStepLabel>Verify Purchase Order(s)</ng-template>
											<table class="table table-sm w-100">
												<div class="col-12 text-right" *ngIf="results.length">

													<button mat-raised-button color="warn" matStepperNext>Next</button>
												</div>
												<ng-container *ngFor="let vendor of po_vendors_found">

													<div class="col-12 m-0 p-0 mb-2 mt-2">
														<button mat-raised-button color="primary" (click)="exportTemplate()" *ngIf="this.config.env.package == 'tires' && results[vendor][0].export_template ">
														<i class="fa fa-file-excel-o"></i>&nbsp;&nbsp;TREADNET</button>&nbsp;&nbsp;&nbsp;
													</div>

													<div class="card mt-2" class="col-md-12">
														<!-- *ngIf="vendorHasFillable(vendor)" -->
														<div class="row p-0 m-0">

															<div class="col-md-6">
																<button mat-raised-button color="accent" matStepperPrevious>Previous</button>
															</div>
															<div class="col-md-6 text-right">
																<ng-container *ngIf="!sending">
																	<button mat-raised-button color="warn" (click)="printResults(vendor)">
																		<i class="fa fa-file-pdf-o"></i> &nbsp;Print PO Preview</button>
																	&nbsp;&nbsp;
																	<button n-submit mat-raised-button aria-label="Change Vendor" color="accent" (click)="submitPo(vendor)" class="mt-2">
																		Next
																	</button>
																</ng-container>
																<ng-container *ngIf="sending">
																	<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
																		<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30">
																		</circle>
																	</svg>
																</ng-container>
															</div>
														</div>
														<div class="col-md-12">
															<h4 class="card-title text-left mt-3"><b>{{ vendor }}</b></h4>
														</div>
														<div class="row p-0 m-0" *ngIf="!vendorHasFillable(vendor)">
															<div class="col-6">
																<h4>No Items To Order</h4>
															</div>
														</div>
														<div class="card-body">
															<div class="row " *ngFor="let line of results[vendor]">
																<ng-container *ngIf="line.qty_purchase > 0 ">
																	<div class="col-md-12 border-top text-left">
																		<div class="row">
																			<div class="col-md-1 p-0" [ngClass]="{'bg-danger text-white bolder': line.total_available == 0 , 'bg-warning text-dark bolder': line.target_purchase > line.total_available && line.total_available > 0 }">
																				<button mat-icon-button aria-label="Change Vendor" color="primary" (click)="viewPurchData(line)">
																					<mat-icon class="mt-2 smaller-font">edit</mat-icon>
																				</button>
																				<button class="mb-0 pt-0 pb-0 " mat-icon-button color="accent" (click)="removeItem(line,vendor)">
																					<mat-icon>remove</mat-icon>
																				</button>
																			</div>
																			<div class="col-md-3 mt-2 p-0">
																				<b>{{ line.brand_data.brand }}</b><br />
																				{{ line.stockid }}<br />
																				{{ line.description }}
																			</div>
																			<div class="col-md-3">
																				<ng-container>
																					<div class="col-md-12 p-0">
																						<ul class="entry-list p-0 m-0 bold">
																							<li>
																								<div class="spec-label">QOH</div>
																								<div class="spec-value">{{ line.qoh }}</div>
																							</li>
																						</ul>
																					</div>
																				</ng-container>
																				<ng-container *ngIf="line.selected_option">
																					<div class="col-md-12 p-0" *ngFor="let remote of line.selected_option.remote">
																						<ul class="entry-list p-0 m-0 bold">
																							<li>
																								<div class="spec-label">{{ remote.feedlabel }}:</div>
																								<div class="spec-value">{{ remote.qty }}</div>
																							</li>
																						</ul>
																					</div>
																				</ng-container>
																			</div>
																			<div class="col-md-2">
																				<mat-form-field appearance="outline">
																					<mat-label>Qty</mat-label>
																					<span matPrefix>#</span>
																					<input matInput type="number" value="{{ line.qty_purchase | number }}" (input)="updateQuantity($event.target.value, line )" class="text-right form-control">
																					<span matSuffix>/ {{ line.target_purchase }}</span>
																				</mat-form-field>
																			</div>
																			<div class="col-md-2">
																				<mat-form-field appearance="outline" class="">
																					<mat-label>
																						Price
																					</mat-label>
																					<span matPrefix>$</span>
																					<input matInput (input)="updatePrice($event.target.value, line )" value="{{ line.selected_option.price | number:'1.2-2' }}" class="text-right form-control" appSelectOnFocus>
																				</mat-form-field>
																			</div>
																			<div class="col-md-1 mt-4">
																				<mat-label>
																					Total
																				</mat-label>
																				<b>{{ line.selected_option.price * line.qty_purchase | currency }}</b>
																			</div>
																		</div>
																	</div>
																</ng-container>
															</div>
														</div>
													</div>
												</ng-container>
											</table>
										</mat-step>
									</mat-stepper>
								</div>
							</div>
						</div>

					</mat-tab>
					<mat-tab label="Un-fillable Items">
						<h4 *ngIf="!watch_items.length" class="mt-3">No Un-fillable Items Found</h4>
						<ng-container *ngIf="watch_items.length">
							<div class="row p-0 m-0">
								<div class="col-12 text-right mt-2 mb-2">
									<button mat-raised-button aria-label="Discontinue Items" color="primary" (click)="discontinueItems()" >
										Discontinue Items
									</button>
								</div>
							</div>
							<div class="wrapper">
								<table class="table table-fixed w-100">
									<thead>
										<tr>
											<th class="header">Discontinue</th>
											<th class="header">Vendor</th>
											<th class="header">Item</th>
											<th class="header text-center">Committed</th>
											<th class="header text-center">OnOrder</th>
											<th class="header text-center">Avail</th>
											<th class="header">QOH</th>
											<th class="header">MIN</th>
											<th class="header">MAX</th>
											<th class="header text-right">Total Available</th>
											<th class="header text-right">Order Qty</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let item of watch_items">
											<td class="text-center">
												<mat-checkbox [(ngModel)]="item.watchlist"></mat-checkbox>
											</td>
											<td>
												<button class="mb-0 pt-0 pb-0 " mat-icon-button color="warn" (click)="viewPurchData(item)">
													<mat-icon>settings</mat-icon>
												</button>
												{{ item.vendor }}
											</td>
											<!--<td (click)="getItemHistory(item)"> {{ item.stockid }}</td>-->
											<td><b>{{ item.brand_data.brand }}</b><br>{{ item.stockid }}<br />
												{{ item.description }}
											</td>
											<td class="text-center">{{ item.qos }}</td>
											<td class="text-center">{{ item.qop }}</td>


											<td class="text-center">{{ ( item.qoh + item.qop ) - item.qos }}</td>
											<td class="text-center">{{ item.qoh }}</td>
											<td class="text-center">{{ item.minimum }}</td>
											<td class="text-center">{{ item.maximum }}</td>
											<td class="text-right">
												{{ item.total_remote_stock }}



											</td>
											<td class="text-right bolder">
												{{ item.target_purchase }}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</ng-container>
					</mat-tab>
				</mat-tab-group>
			</ng-container>
		</ng-container>
	</div>
</div>
